import { useState } from 'react';
import './login.css';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../../services/auth.service';
import { setItemToLacalStorage } from '../../helpers/localstorage.helper';
import { useAppDispatch } from '../../store/hooks';
import { login } from '../../store/user/userSlice';

interface ILoginUser {
  login: string;
  password: string;
}

interface IUserErrors {
  login?: string;
  password?: string;
  general?: string;
}

function Login() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [user, setUser] = useState<ILoginUser>({
    login: '',
    password: '',
  });

  const [errors, setErrors] = useState<IUserErrors>({});

  const validateForm = () => {
    const tempErrors: IUserErrors = {};

    if (!/^[a-zA-Z0-9._-]{3,}$/.test(user.login)) {
      tempErrors.login =
        'Некорректный логин. Логин должен содержать только буквы, цифры, точки, дефисы и подчеркивания и иметь длину не менее 3 символов.';
    }
    if (!/^\w+$/.test(user.password)) {
      tempErrors.password = 'Логин должен содержать только буквы, цифры и нижние подчеркивания.';
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrors((prevState) => ({
      ...prevState,
      [name]: '',
    }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const data = await AuthService.login({ ...user });

        if (data) {
          setItemToLacalStorage('access_token', data.access_token);
          setItemToLacalStorage('refresh_token', data.refresh_token);
          dispatch(login(data.user));
          navigate(`/account/${data.user.role}`);
        }
      } catch (error: any) {
        setErrors((prevState) => ({
          ...prevState,
          general: error.message,
        }));
      }
    }
  };

  return (
    <div className="login">
      <div className="createUser">
        <header className="createUserHeader">Вход</header>
        <form onSubmit={handleSubmit} className="login-form">
          {errors.general && <div className="error general-error">{errors.general}</div>}
          <div className="formGroup">
            <label htmlFor="login">Логин</label>
            <input
              placeholder="Введите логин"
              type="text"
              id="login"
              name="login"
              value={user.login}
              onChange={handleChange}
              required
            />
            {errors.login && <div className="error">{errors.login}</div>}
          </div>
          <div className="formGroup">
            <label htmlFor="password">Пароль</label>
            <input
              placeholder="Введите пароль"
              type="password"
              id="password"
              name="password"
              value={user.password}
              onChange={handleChange}
              required
            />
            {errors.password && <div className="error">{errors.password}</div>}
          </div>
          <div className="formActions">
            <button type="submit" className="btn btnPrimary">
              Войти
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
